import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TRACKING_CONFIG, TrackingConfig, TrackingService } from '../index';

export function provideTracking(config: TrackingConfig): EnvironmentProviders {
    return makeEnvironmentProviders([{ provide: TRACKING_CONFIG, useValue: config }, TrackingService]);
}
